// extracted by mini-css-extract-plugin
module.exports = {"container":"_nQKUkx7qGZpV2ON7damh","body":"_2g64MgFkfblj3kCxjv6AKx"};